import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from 'utils/components/icon';
import classnames from 'classnames';

class CheckboxInput extends Component {
  handleChange() {
    if (!this.props.disabled) {
      var checkboxInput = this.refs.checkboxInput;
      var value = !checkboxInput.checked;
      this.props.onChange(value);
    }
  }
  render() {
    var checked = this.props.value;
    var { text, disabled } = this.props;

    var checkedIcon = <Icon className="checked-icon" name="check" />;

    var cbClassName = classnames('label-box light', {
      checked: checked,
      disabled: disabled
    });

    var textClassName = classnames('text', {
      disabled: disabled
    });

    return (
      <div className="checkbox-light">
        <div className={cbClassName} onClick={this.handleChange.bind(this)}>
          <span className="checkbox">
            <input
              disabled={disabled}
              ref="checkboxInput"
              onChange={this.handleChange.bind(this)}
              checked={checked}
              type="checkbox"
            />
            {checked ? checkedIcon : null}
          </span>
          <label className={textClassName}>{text}</label>
        </div>
      </div>
    );
  }
}

CheckboxInput.propTypes = {
  value: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

CheckboxInput.contextTypes = {
  executeAction: PropTypes.func.isRequired
};

CheckboxInput.defaultProps = {
  disabled: false
};

CheckboxInput.displayName = 'CheckboxInput';

export default CheckboxInput;
